module.exports = __webpack_public_path__ + "img/log.014d58ea.svg";